// extracted by mini-css-extract-plugin
module.exports = {"buttonsWrapper":"PricesPageKcalWrapper_buttonsWrapper__2sRVN"};